"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recipeNameFragment = void 0;
const client_1 = require("@apollo/client");
exports.recipeNameFragment = client_1.gql `
  fragment recipeName on Recipe {
    __typename
    id
    name
    pictureUrl
    smallPictureUrl
    source
    rating
    createdAt
  }
`;
//# sourceMappingURL=recipeName.js.map